import { defineMessages } from "react-intl";

const messages = defineMessages({
  autoFilledPlaceholder: {
    id: "leadFinder.addRecordsWizard.fillFieldsStep.autoFilledPlaceholder",
    defaultMessage: "Auto-filled from Lead Finder",
    description: "Auto-filled field placeholder",
  },
  autoFilledValuesCaption: {
    id: "leadFinder.addRecordsWizard.fillFieldsStep.autoFilledValuesCaption",
    defaultMessage:
      "Values will be filled for all new records. You can edit individual records after creation.",
    description: "Auto filled values caption",
  },
  finishButtonTitleCompany: {
    id: "leadFinder.addRecordsWizard.fillFieldsStep.finishButton.company",
    defaultMessage:
      "Add as {sourceObject, select, standard {{count, plural, one {Company} other {Companies}}} leadCompanies {{count, plural, one {Lead} other {Leads}}} siteCompanies {{count, plural, one {Site} other {Sites}}} projectCompanies {{count, plural, one {Project} other {Projects}}} shopCompanies {{count, plural, one {Shop} other {Shops}}} other {{label}}}",
    description:
      'Lead Finder wizard finish button, named after the source object. The record type name comes from the select: the web\'s own word for a known type, otherwise {label}, a name an admin typed or an integration sent. Keep {label} in its base form. In es, pt and fr, no article, adjective or participle may agree with it: put gendered words on the noun "record" with the name in parentheses, or put a verb before the name. In a choice that creates a record, use a form like "Добавить: {label}".',
  },
  finishButtonTitlePerson: {
    id: "leadFinder.addRecordsWizard.fillFieldsStep.finishButton.person",
    defaultMessage:
      "Add as {sourceObject, select, standard {{count, plural, one {Person} other {People}}} partnerPeople {{count, plural, one {Partner} other {Partners}}} leadPeople {{count, plural, one {Lead} other {Leads}}} staffMemberPeople {{count, plural, one {Staff Member} other {Staff Members}}} leadPersonnel {{count, plural, one {Lead Personnel} other {Lead Personnel}}} other {{label}}}",
    description:
      'Lead Finder wizard finish button, named after the source object. The record type name comes from the select: the web\'s own word for a known type, otherwise {label}, a name an admin typed or an integration sent. Keep {label} in its base form. In es, pt and fr, no article, adjective or participle may agree with it: put gendered words on the noun "record" with the name in parentheses, or put a verb before the name. In a choice that creates a record, use a form like "Добавить: {label}".',
  },
  partiallyFilledCaption: {
    id: "leadFinder.addRecordsWizard.fillFieldsStep.partiallyFilledCaption",
    defaultMessage: "Value is only applied to leads that don’t already have a {fieldName}",
    description: "Partially filled field caption",
  },
  uniqueFieldRequiredTooltip: {
    id: "leadFinder.addRecordsWizard.fillFieldsStep.uniqueField.required.tooltip",
    defaultMessage:
      "There is a required field where the value must be unique, so only one lead can be added at a time.",
    description: "Tooltip for send button when a custom field is required and unique",
  },
});

export default messages;
